<template>
  <f7-page no-swipeback @page:init="init" @page:beforeout="beforeOut">
    <f7-navbar title="訂單詳情 Order Info" back-link="返回 Back"></f7-navbar>

    <f7-list media-list v-if="this.categories_products && this.categories_products.length > 0">
      <f7-list-item
        title="狀態 STATUS"
        :subtitle="this.order_data.status"
      ></f7-list-item>

      <f7-list-item
        title="訂單日期 ORDER DATE"
        :subtitle="this.order_data.created_at"
      ></f7-list-item>

      <f7-list-item
        title="用戶 USER"
        :subtitle="this.order_data.user.name"
      ></f7-list-item>

      <f7-list-item
        title="工場 Warehouse"
        :subtitle="this.order_data.store.name"
      ></f7-list-item>

      <f7-list-item
        title="備註 REMARKS"
        :subtitle="this.order_data.remark"
      ></f7-list-item>

      <f7-list-item>
        <f7-button raised @click="() => print()">列印 Print - 全部 All</f7-button>
      </f7-list-item>

      <f7-list-item :key="category.id" v-for="category in categories" v-show="hasSubCategoriesData(category.id)">
        <f7-button raised @click="() => print(category.id)">列印 Print - {{ category.name }}</f7-button>
      </f7-list-item>

      <f7-list-group :key="category_index" v-for="(category, category_index) in categories_products">
        <f7-list-item :title="category.category_name" group-title></f7-list-item>
        <f7-list-item
          v-for="product in category.products"
          :key="product.id"
          :title="product.name"
          class="text-orange"
        >
          <list-product-item
            :product="product"
            :modified="product.quantity != product.original_quantity"
            :readonly="order_data.status === 'Completed'"
            @updated="(quantity) => handleQuantityChanged(category.category_id, product.id, quantity)"
          />
        </f7-list-item>
      </f7-list-group>

      <f7-list-group v-if="missing_products.length > 0">
        <f7-list-item title="工場備註 Warehouse Remarks" group-title></f7-list-item>
        <f7-list-item v-for="product in missing_products" :key="product.id" :title="`${product.name} 欠Missing ${product.difference} 件Unit`"></f7-list-item>
      </f7-list-group>
    </f7-list>

    <f7-toolbar position="bottom" v-if="this.categories_products && this.categories_products.length > 0">
      <div class="bottom-overview" style="font-size: 15px">
        {{ products_total }} 項 Items，{{ provideTotalQuantity }} 件
        <br>
        Unit，合計 Total ${{ displaySubtotal }}
      </div>
      <f7-link @click="updateOrder">更新 Update</f7-link>
    </f7-toolbar>
  </f7-page>
</template>

<script>
import ListProductItem from './ListProductItem.vue'
import { format, parseISO } from 'date-fns'
import axios from 'axios'

export default {
  components: {
    ListProductItem,
  },

  props: {
    orderId: String,
  },

  data() {
    return {
      order_data: {},
      categories_products: [],
      original_data: {},
      categories: [],
      categories_subcategories: [],
      subcategory_ids: [],
    }
  },

  computed: {
    products_total() {
      return this.order_data.products.length
    },
    provideTotalQuantity() {
      if (! this.categories_products) {
        return 0;
      }

      return this.categories_products.reduce((total, category) => {
        const productQty = category.products.reduce((subtotal, product) => {
          return subtotal + product.quantity
        }, 0)

        return total + productQty
      }, 0)
    },
    displaySubtotal() {
      if (! this.categories_products) {
        return 0;
      }

      const total = this.categories_products.reduce((total, category) => {
        const productSubtotal = category.products.reduce((subtotal, product) => {
          return subtotal + (product.quantity * product.price)
        }, 0)

        return total + productSubtotal
      }, 0)

      return Math.round(total * 10) / 10
    },
    missing_products() {

      let missing_products = []

      for (let i = 0; i < this.categories_products.length; i++) {
        for (let j = 0; j < this.categories_products[i].products.length; j++) {
          let product = this.categories_products[i].products[j]

          if (product.quantity != product.original_quantity) {
            missing_products.push({
              id: product.id,
              name: product.name,
              category_id: this.categories_products[i].category_id,
              difference: product.original_quantity - product.quantity,
              supply_quantity: product.quantity,
              supply_subtotal: product.quantity * product.price,
            })
          }
        }
      }

      return missing_products
    }
  },

  methods: {
    init() {
      this.fetchOrder()

      axios.get('/api/categories').then(({ data }) => {
        this.categories = data

        this.categories_subcategories = this.categories.map((root_category) => {
          return {
            id: root_category.id,
            subcategories: root_category.subcategories.map((subcategory) => {
              return subcategory.id
            })
          }
        })
      })
    },
    fetchOrder() {
      return new Promise((resolve, reject) => {
        axios.get(`/api/orders/${this.orderId}`)
          .then(({ data }) => {

            this.original_data = data

            let subCategories = [...new Set(data.products.map(product => product.category.id))];
            this.subcategory_ids = subCategories

            let structured = subCategories.map((category_id) => {
              let categoryFound = data.products.find(obj => obj.category.id === category_id)

              return {
                category_id: category_id,
                category_name: categoryFound.category.name,
                products: data.products.filter((item) => {
                  return item.category.id === category_id
                }).map((product) => {

                  let isSupplyConfirmed = product.supply_confirmed_at != null

                  return {
                    id: product.id,
                    name: product.product_name,
                    subname: product.product_subname,
                    quantity: isSupplyConfirmed ? product.supply_quantity : product.quantity,
                    original_quantity: product.quantity,
                    price: (product.price / 100),
                    expired_date: product.expired_date,
                    features: [], // product.properties
                  }
                })
              }
            })

            data.created_at = format(parseISO(data.created_at), 'yyyy-MM-dd HH:mm')

            this.categories_products = structured

            this.order_data = data

            resolve()
          }).catch((e) => {
            reject(e)
          })
      })
    },
    print(root_category_id) {
      this.saveOrderUpdates()
        .then(() => {
          this.fetchOrder()
            .then(() => {
              if (typeof root_category_id !== 'undefined') {
                let category_ids = this.categories_subcategories.find(root_category => root_category.id === root_category_id).subcategories || []

                let new_total = this.categories_products.reduce((accumulator, category) => {
                  return category.products.reduce((accumulator_products, product) => {
                    let quantity = product.quantity

                    return (category_ids.includes(category.category_id)) ? (accumulator_products + (quantity * product.price)) : accumulator_products
                  }, accumulator)
                }, 0)

                new_total = (new_total * 100)

                let new_quantity = this.categories_products.reduce((accumulator, category) => {
                  return category.products.reduce((accumulator_products, product) => {
                    let quantity = product.quantity

                    return (category_ids.includes(category.category_id)) ? (accumulator_products + quantity) : accumulator_products
                  }, accumulator)
                }, 0)

                let new_data = JSON.parse(JSON.stringify(this.original_data))
                new_data.total_quantity = new_quantity
                new_data.total = new_total

                let new_products = new_data.products
                  .map(product => {
                    product.quantity = product.supply_confirmed_at != null ? product.supply_quantity : product.quantity
                    product.subtotal = product.quantity * product.price

                    return product
                  })
                  .filter(product => category_ids.includes(product.category_id))
                new_data.products = new_products

                new_data.remark += "\n" + this.missing_products
                  .filter((product) => {
                    return category_ids.includes(product.category_id)
                  })
                  .map((product) => {
                    return `${product.name} 欠Missing ${product.difference} 件Unit`
                  })
                  .join("\n")

                window.ReactNativeWebView.postMessage(JSON.stringify(new_data))
              } else {

                let new_total = this.categories_products.reduce((accumulator, category) => {
                  return category.products.reduce((accumulator_products, product) => {
                    let quantity = product.quantity

                    return accumulator_products + (quantity * product.price)
                  }, accumulator)
                }, 0)

                new_total = (new_total * 100)

                let new_quantity = this.categories_products.reduce((accumulator, category) => {
                  return category.products.reduce((accumulator_products, product) => {
                    let quantity = product.quantity

                    return accumulator_products + quantity
                  }, accumulator)
                }, 0)

                let new_data = JSON.parse(JSON.stringify(this.original_data))
                new_data.total_quantity = new_quantity
                new_data.total = new_total

                let new_products = new_data.products
                  .map(product => {
                    product.quantity = product.supply_confirmed_at != null ? product.supply_quantity : product.quantity
                    product.subtotal = product.quantity * product.price

                    return product
                  })

                new_data.products = new_products

                new_data.remark += "\n" + this.missing_products.map((product) => {
                  return `${product.name} 欠Missing ${product.difference} 件Unit`
                }).join("\n")

                window.ReactNativeWebView.postMessage(JSON.stringify(new_data))
              }
            })
          })
    },
    hasSubCategoriesData(root_category_id) {
      let category_ids = this.categories_subcategories.find(root_category => root_category.id === root_category_id).subcategories || []

      return category_ids.filter(value => this.subcategory_ids.includes(value)).length > 0
    },
    updateOrder() {
      this.$f7.dialog.preloader('提交中 Submitting')

      this.saveOrderUpdates().then(() => {
        this.$f7.dialog.close()

        var actionSheet = this.$f7.actions.create({
          buttons: [
            // First group
            [
              {
                text: '狀態更新 Status Update',
                label: true,
              },
              {
                text: '待處理 Pending',
                onClick: () => {
                  this.updateOrderStatus('Pending')
                }
              },
              {
                text: '處理中 Processing',
                onClick: () => {
                  this.updateOrderStatus('Processing')
                }
              },
              {
                text: '已完成 Completed',
                onClick: () => {
                  this.updateOrderStatus('Completed')
                }
              },
              {
                text: '取消訂單 Cancel Order',
                onClick: () => {
                  this.updateOrderStatus('Canceled')
                }
              }
            ],
            // Second group
            [
              {
                text: '返回 Back',
                color: 'red'
              }
            ]
          ]
        });

        actionSheet.open()
      }).catch(() => {
        this.$f7.dialog.close()
        this.$f7.dialog.alert('發生錯誤，請重試。An Error Occurred, Please Try Again.')
      })
    },
    beforeOut() {
      this.saveOrderUpdates().catch(() => {})
    },
    saveOrderUpdates() {
      const all_categories_products = this.categories_products.map(categoryProduct => {
        return categoryProduct.products.map(item => {
          return {
            category_id: categoryProduct.category_id,
            difference: item.original_quantity - item.quantity,
            id:item.id,
            name: item.name,
            supply_quantity: item.quantity,
            supply_subtotal: item.quantity * item.price
          }
        })
      }).flat()

      return axios.put(`/api/orders/${this.orderId}`, {
        order_products: all_categories_products,
      })
    },
    updateOrderStatus(status) {
      this.$f7.dialog.preloader('提交中 Submitting')

      axios.put(`/api/orders/${this.orderId}`, {
        status,
      }).then(() => {
        return this.fetchOrder()
      }).then(() => {
        this.$f7.dialog.close()
      }).catch(() => {
        this.$f7.dialog.close()
        this.$f7.dialog.alert('發生錯誤，請重試。An Error Occurred, Please Try Again.')
      })
    },
    handleQuantityChanged(category_id, product_id, quantity) {
      let data = JSON.parse(JSON.stringify(this.categories_products))
      let category = data.find((element) => element.category_id === category_id)
      let product = category.products.find((product) => product.id === product_id)

      if (quantity > product.original_quantity) {
        return
      }

      product.quantity = quantity

      this.categories_products = data
    },
  }
}
</script>
